import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  listHeader: {
    display: "flex",
  },
  today: {
    fontWeight: theme.typography.fontWeightHeavy,
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(1),
    width: "50%",
  },
  refreshButton: {
    width: "50%",
    justifyContent: "flex-end",
    display: "flex",
  },
}));
